'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var fieldLabel = require('./field-label-4ed9b7f8.js');
var fileBlock = require('./file-block-d6c87493.js');

var BASE_ERROR_TEXT = 'There was an error uploading your file(s).';
var ERROR_MAX_FILES = 'File limit exceeded';
var ERROR_MAX_SIZE = 'Total File size exceeded';
var UPLOADED_FILE_SIZE = 'Uploaded file size:';

// eslint-disable-next-line max-len
var resolveErrorSizeLimit = function (limit) { return "One or more of the file sizes exceeded the " + limit + "MB limit."; };

var bytesToMB = function (bytes) { return bytes / (1000 * 1000); };
var calculateTotalFileSize = function (allFiles) {
    var size = 0;
    Array.from(allFiles).forEach(function (file) { (size += file.size); });
    return bytesToMB(size);
};
var fileListToArray = function (fileList, maxSizePerFile, setErrorText) {
    var array = [];
    var fileSize = 0;
    var fileNum = 0;
    Array.from(fileList).forEach(function (file) {
        if (maxSizePerFile && bytesToMB(file.size) > maxSizePerFile) {
            setErrorText(BASE_ERROR_TEXT + " " + resolveErrorSizeLimit(maxSizePerFile) + " " + UPLOADED_FILE_SIZE + " " + bytesToMB(file.size) + "(MB)");
            return;
        }
        array.push(file);
        fileSize += bytesToMB(file.size);
        fileNum += 1;
    });
    return [array, fileSize, fileNum];
};
var fileLimitReached = function (fileLimit, files, numFiles) {
    if (fileLimit) {
        return fileLimit - numFiles < files.length;
    }
    return false;
};
var maxSizeReached = function (maxSizeTotal, files, totalFileSize) {
    if (maxSizeTotal) {
        return maxSizeTotal < calculateTotalFileSize(files) + totalFileSize;
    }
    return false;
};
var useFileUpload = function (_a) {
    var files = _a.files, maxSizeTotal = _a.maxSizeTotal, fileLimit = _a.fileLimit, onUploadComplete = _a.onUploadComplete, setErrorText = _a.setErrorText, errorUploadingText = _a.errorUploadingText, errorFileLimitText = _a.errorFileLimitText, errorSizeLimitText = _a.errorSizeLimitText, setFiles = _a.setFiles, setTotalFileSize = _a.setTotalFileSize, setNumFiles = _a.setNumFiles, maxSizePerFile = _a.maxSizePerFile, numFiles = _a.numFiles, totalFileSize = _a.totalFileSize;
    var callback = React.useCallback(function (event) {
        var uploadFiles = event.target.files;
        if (fileLimitReached(fileLimit, uploadFiles, numFiles)) {
            setErrorText((errorUploadingText || BASE_ERROR_TEXT) + " " + (errorFileLimitText || ERROR_MAX_FILES));
            return;
        }
        if (maxSizeReached(maxSizeTotal, uploadFiles, totalFileSize)) {
            setErrorText((errorUploadingText || BASE_ERROR_TEXT) + " " + (errorSizeLimitText || ERROR_MAX_SIZE));
            return;
        }
        var _a = tslib_es6.__read(fileListToArray(uploadFiles, maxSizePerFile, setErrorText), 3), newFiles = _a[0], fileSize = _a[1], fileNum = _a[2];
        var combinedFiles = tslib_es6.__spread(files, newFiles);
        setTotalFileSize(totalFileSize + fileSize);
        setNumFiles(numFiles + fileNum);
        setFiles(combinedFiles);
        onUploadComplete && onUploadComplete(combinedFiles);
    }, [files, maxSizeTotal, fileLimit]);
    return callback;
};
var useFileHelpers = function (_a) {
    var maxSizeTotal = _a.maxSizeTotal, fileLimit = _a.fileLimit, onDelete = _a.onDelete, uploadedFiles = _a.uploadedFiles;
    var _b = tslib_es6.__read(React.useState(uploadedFiles || []), 2), files = _b[0], setFiles = _b[1];
    var _c = tslib_es6.__read(React.useState(0), 2), totalFileSize = _c[0], setTotalFileSize = _c[1];
    var _d = tslib_es6.__read(React.useState(uploadedFiles ? uploadedFiles === null || uploadedFiles === void 0 ? void 0 : uploadedFiles.length : 0), 2), numFiles = _d[0], setNumFiles = _d[1];
    var _e = tslib_es6.__read(React.useState(false), 2), isDisabled = _e[0], setIsDisabled = _e[1];
    var deleteFile = React.useCallback(function (index) { return function () {
        var newArray = tslib_es6.__spread(files);
        setTotalFileSize(totalFileSize - bytesToMB(newArray.splice(index, 1)[0].size));
        setNumFiles(numFiles - 1);
        setFiles(newArray);
        onDelete && onDelete(newArray);
    }; }, [files]);
    React.useEffect(function () {
        if (maxSizeTotal) {
            !isDisabled && totalFileSize >= maxSizeTotal && setIsDisabled(true);
            isDisabled && totalFileSize < maxSizeTotal && setIsDisabled(false);
        }
    }, [totalFileSize]);
    React.useEffect(function () {
        if (fileLimit) {
            isDisabled && fileLimit > numFiles && setIsDisabled(false);
            !isDisabled && fileLimit <= numFiles && setIsDisabled(true);
        }
    }, [numFiles]);
    return [files, setFiles, isDisabled, totalFileSize, setTotalFileSize, numFiles, setNumFiles, deleteFile];
};
var useFileUploadState = function (_a) {
    var maxSizeTotal = _a.maxSizeTotal, maxSizePerFile = _a.maxSizePerFile, fileLimit = _a.fileLimit, onUploadComplete = _a.onUploadComplete, onDelete = _a.onDelete, setErrorText = _a.setErrorText, errorUploadingText = _a.errorUploadingText, errorFileLimitText = _a.errorFileLimitText, errorSizeLimitText = _a.errorSizeLimitText, uploadedFiles = _a.uploadedFiles;
    var _b = tslib_es6.__read(useFileHelpers({
        maxSizeTotal: maxSizeTotal, fileLimit: fileLimit, onDelete: onDelete, uploadedFiles: uploadedFiles,
    }), 8), files = _b[0], setFiles = _b[1], isDisabled = _b[2], totalFileSize = _b[3], setTotalFileSize = _b[4], numFiles = _b[5], setNumFiles = _b[6], deleteFile = _b[7];
    var onFileUpload = useFileUpload({
        files: files,
        maxSizeTotal: maxSizeTotal,
        fileLimit: fileLimit,
        onUploadComplete: onUploadComplete,
        setErrorText: setErrorText,
        errorUploadingText: errorUploadingText,
        errorFileLimitText: errorFileLimitText,
        errorSizeLimitText: errorSizeLimitText,
        setFiles: setFiles,
        setTotalFileSize: setTotalFileSize,
        setNumFiles: setNumFiles,
        maxSizePerFile: maxSizePerFile,
        numFiles: numFiles,
        totalFileSize: totalFileSize,
    });
    return [files, isDisabled, numFiles, deleteFile, onFileUpload];
};
var useReferenceButtonHandler = function (_a) {
    var errorText = _a.errorText, setErrorText = _a.setErrorText, inputRef = _a.inputRef, onUploadClick = _a.onUploadClick;
    var callback = React.useCallback(function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        errorText && setErrorText('');
        onUploadClick && onUploadClick();
    }, [errorText]);
    return callback;
};

// eslint-disable-next-line max-lines-per-function
var FileUpload = function (_a) {
    var acceptedFileTypes = _a.acceptedFileTypes, buttonLabel = _a.buttonLabel, dataCy = _a.dataCy, dataTestId = _a.dataTestId, disabled = _a.disabled, _b = _a.fileLimit, fileLimit = _b === void 0 ? 1 : _b, maxSizePerFile = _a.maxSizePerFile, maxSizeTotal = _a.maxSizeTotal, onDelete = _a.onDelete, onUploadClick = _a.onUploadClick, onUploadComplete = _a.onUploadComplete, required = _a.required, subtitle = _a.subtitle, title = _a.title, uploadedFiles = _a.uploadedFiles, errorUploadingText = _a.errorUploadingText, errorFileLimitText = _a.errorFileLimitText, errorSizeLimitText = _a.errorSizeLimitText, uploadButtonDataTestId = _a.uploadButtonDataTestId;
    var inputRef = React.useRef(null);
    var _c = tslib_es6.__read(React.useState(''), 2), errorText = _c[0], setErrorText = _c[1];
    var _d = tslib_es6.__read(useFileUploadState({
        maxSizeTotal: maxSizeTotal,
        fileLimit: fileLimit,
        maxSizePerFile: maxSizePerFile,
        onUploadComplete: onUploadComplete,
        onDelete: onDelete,
        setErrorText: setErrorText,
        errorUploadingText: errorUploadingText,
        errorFileLimitText: errorFileLimitText,
        errorSizeLimitText: errorSizeLimitText,
        uploadedFiles: uploadedFiles,
    }), 5), files = _d[0], isDisabled = _d[1], numFiles = _d[2], deleteFile = _d[3], onFileUpload = _d[4];
    var onButtonClick = useReferenceButtonHandler({
        errorText: errorText, setErrorText: setErrorText, inputRef: inputRef, onUploadClick: onUploadClick,
    });
    return (React__default.createElement(fileBlock.Container, null,
        React__default.createElement(fieldLabel.FieldLabel, { label: title, dataCy: dataCy, dataTestId: dataTestId, required: required }),
        numFiles > 0 && React__default.createElement(fileBlock.FileBlock, { files: files, deleteFile: deleteFile }),
        errorText && (React__default.createElement(fileBlock.ErrorText, null, errorText)),
        React__default.createElement(fileBlock.UploadWrapper, { htmlFor: "fileupload" },
            React__default.createElement(fileBlock.UploadButton, { "data-testid": uploadButtonDataTestId, text: buttonLabel || 'Upload a file', onClick: onButtonClick, variant: "secondary", disabled: isDisabled || disabled }),
            React__default.createElement(fileBlock.InvisibleInput, { ref: inputRef, type: "file", id: "fileupload", value: "", multiple: fileLimit > 1, accept: acceptedFileTypes, onChange: onFileUpload })),
        subtitle && (React__default.createElement(fileBlock.Subtitle, null, subtitle))));
};

exports.FileUpload = FileUpload;
